export class CombinedBoundary {
    constructor(sceneObjects, orientation, boundingBox, originalBoundingBox) {
        this.sceneObjects = sceneObjects;
        this.orientation = orientation;
        this.boundingBox = boundingBox;
        this.originalBoundingBox = originalBoundingBox;
    }
}
